import React from "react";

const ManualIcon = ({width="26",height="24"}) => {
  return (
    <div>
      <svg
        width={width}
        height={height}
        viewBox="0 0 26 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C13.43 22 14.8 21.7 16.03 21.15"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g clip-path="url(#clip0_46_3787)">
          <path
            d="M19.5 21.3334V19.6667M19.5 16.3334V14.6667M18.6667 15.5H20.3334M18.6667 20.5H20.3334M22.3334 15L21.7553 16.503C21.6613 16.7474 21.6143 16.8696 21.5412 16.9724C21.4764 17.0635 21.3968 17.1431 21.3057 17.2079C21.2029 17.281 21.0807 17.328 20.8363 17.422L19.3334 18L20.8363 18.5781C21.0807 18.6721 21.2029 18.7191 21.3057 18.7922C21.3968 18.857 21.4764 18.9366 21.5412 19.0277C21.6143 19.1305 21.6613 19.2527 21.7553 19.4971L22.3334 21L22.9114 19.4971C23.0054 19.2527 23.0524 19.1305 23.1255 19.0277C23.1903 18.9366 23.2699 18.857 23.361 18.7922C23.4638 18.7191 23.586 18.6721 23.8304 18.5781L25.3334 18L23.8304 17.422C23.586 17.328 23.4638 17.281 23.361 17.2079C23.2699 17.1431 23.1903 17.0635 23.1255 16.9724C23.0524 16.8696 23.0054 16.7474 22.9114 16.503L22.3334 15Z"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <g clip-path="url(#clip1_46_3787)">
          <path
            d="M7.69232 15.484C8.76289 14.3485 10.2164 13.6507 11.8173 13.6507C13.4183 13.6507 14.8717 14.3485 15.9423 15.484M13.8798 9.75482C13.8798 10.8939 12.9564 11.8173 11.8173 11.8173C10.6782 11.8173 9.75482 10.8939 9.75482 9.75482C9.75482 8.61574 10.6782 7.69232 11.8173 7.69232C12.9564 7.69232 13.8798 8.61574 13.8798 9.75482Z"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_46_3787">
            <rect
              width="8"
              height="8"
              fill="white"
              transform="translate(18 14)"
            />
          </clipPath>
          <clipPath id="clip1_46_3787">
            <rect
              width="11"
              height="11"
              fill="white"
              transform="translate(6 6)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default ManualIcon;
